<div>
    <img src="assets/no-result.svg" alt="No results found" style="width: 100%; max-width: 800px; display: block; margin: 0 auto;">
</div>
